import { render } from "./ProfileLogo.vue?vue&type=template&id=4be4ebf4"
import script from "./ProfileLogo.vue?vue&type=script&lang=js"
export * from "./ProfileLogo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__